module.exports = __webpack_public_path__ + "static/web-page-banner-4fe6cdcea13b2a5fb491de9d54679a04.mp4";